const TOKEN_KEY = 'auth_token'
const CURRENT_USER_KEY = 'current_user'

export default class SessionManager {
  static getAuthToken() {
    return sessionStorage.getItem(TOKEN_KEY) ||
      localStorage.getItem(TOKEN_KEY)
  }

  static getCurrentUser() {
    const user = sessionStorage.getItem(CURRENT_USER_KEY) ||
      localStorage.getItem(CURRENT_USER_KEY)
    return JSON.parse(user)
  }

  static updateCurrentUser(newUser) {
    if(sessionStorage.getItem(CURRENT_USER_KEY)) {
      sessionStorage.setItem(CURRENT_USER_KEY, JSON.stringify(newUser))
    } else {
      localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(newUser))
    }
  }

  static setLoggedIn({token: token, keepLogged: keepLogged = false}) {
    if(keepLogged) {
      localStorage.setItem(TOKEN_KEY, token)
    } else {
      sessionStorage.setItem(TOKEN_KEY, token)
    }
  }

  static setLoggedOut() {
    sessionStorage.removeItem(TOKEN_KEY)
    sessionStorage.removeItem(CURRENT_USER_KEY)

    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(CURRENT_USER_KEY)
  }
}



// WEBPACK FOOTER //
// ./src/utils/session-manager.js